import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.usertask.update;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'USERTASK_UPDATE',
	method: 'POST',
	url: '/usertask/update.json',
});

export { actions, reducer, sagas, selectors };
